module.exports = ".img-fluid {\r\n    box-shadow: 10px 10px 5px #ccc;\r\n    border-radius: 3%;\r\n}"